import React from 'react';

const Header = () => {

  return (
    <header className="text-red py-2">
      <div className="px-4 flex justify-start ">
        <a href="/" className="text-xl mr-10 text-black font-bold hover:text-red-600">Home</a>
        <a
          href="/about"
          className="text-xl mr-4 text-black font-bold hover:text-red-600"
        >
          About ▼
        </a>
      </div>
    </header>
  );
};

export default Header;
